const domains = [

    // Ultra Premium Category
    { domain: "elon-x-trump.com", price: "36.0", currency: "BTC", category: "ultra", ultraPremium: true },
   { domain: "dogextesla.com", price: "600.0", category: "ultra", ultraPremium: true },
   { domain: "elon-trump-maga.com", price: "159.0", category: "ultra", ultraPremium: true },
   { domain: "elontrumpmaga.com", price: "195.0", category: "ultra", ultraPremium: true },
   { domain: "doge-x-elon.com", price: "519.0", category: "ultra", ultraPremium: true },
  
    // Premium Category
    { domain: "ai-x-crypto.com", price: "369.0", category: "premium", isPremium: true },
    { domain: "2009bitcoin.com", price: "519.0", category: "premium", isPremium: true },
    { domain: "2015ethereum.com", price: "369.0", category: "premium", isPremium: true },
    { domain: "2017solana.com", price: "195.0", category: "premium", isPremium: true },
    { domain: "shibainu.dev", price: "519.0", category: "premium", isPremium: true },
    { domain: "solanachain.io", price: "195.0", category: "premium", isPremium: true },
    { domain: "opensource.build", price: "159.0", category: "premium", isPremium: true },
    { domain: "2025bullmarket.com", price: "60.0", category: "premium", isPremium: true },
    { domain: "thememeworld.com", price: "195.0", category: "premium", isPremium: true },
    { domain: "chatgptxcrypto.com", price: "159.0", category: "premium", isPremium: true },
    
    
    // AI & Crypto Integration Category
    { domain: "gptxcrypto.com", price: "56.0", category: "AI & Crypto" },
    { domain: "crypto-x.ai", price: "50.0", category: "AI & Crypto" },
    { domain: "claudecrypto.ai", price: "60.0", category: "AI & Crypto" },
    { domain: "mockingai.com", price: "108.0", category: "AI & Crypto" },
    { domain: "ai-x-crypto.com", price: "369.0", category: "AI & Crypto" },
    { domain: "chatgptxcrypto.com", price: "159.0", category: "AI & Crypto" },
    { domain: "cryptogrok.ai", price: "60.0", category: "AI & Crypto" },
    { domain: "chatgpt-x-crypto.com", price: "519.0", category: "AI & Crypto" },
    { domain: "gamestudioxai.com", price: "200.0", category: "AI & Crypto" },
    { domain: "seicoin.ai", price: "195.0", category: "AI & Crypto" },
    { domain: "suicoin.ai", price: "195.0", category: "AI & Crypto" },
    { domain: "aixbitcoin.world", price: "99.0", category: "AI & Crypto" },
    { domain: "thechaingpt.com", price: "60.0", category: "AI & Crypto" },
    { domain: "solanagpt.dev", price: "99.0", category: "AI & Crypto" },
    { domain: "elon-xai.com", price: "108.0", category: "AI & Crypto" },
    { domain: "cryptoclaude.ai", price: "60.0", category: "AI & Crypto" },
  
    // Usecase & Technologies Category
    { domain: "web-3.tv", price: "108.0", category: "Usecase & Tech" },
    { domain: "web-3.news", price: "108.0", category: "Usecase & Tech" },
    { domain: "solanachain.io", price: "195.0", category: "Usecase & Tech" },
    { domain: "solana-nfts.com", price: "108.0", category: "Usecase & Tech" },
    { domain: "cryptochess.live", price: "30.0", category: "Usecase & Tech" },
    { domain: "cryptochess.org", price: "50.0", category: "Usecase & Tech" },
    { domain: "cryptomusic.live", price: "27.0", category: "Usecase & Tech" },
    { domain: "cryptomusic.world", price: "21.0", category: "Usecase & Tech" },
    { domain: "cryptoflix.net", price: "50.0", category: "Usecase & Tech" },
    { domain: "cryptoflix.app", price: "60.0", category: "Usecase & Tech" },
    { domain: "cryptotv.digital", price: "30.0", category: "Usecase & Tech" },
    { domain: "cryptotv.world", price: "30.0", category: "Usecase & Tech" },
    { domain: "cryptotv.network", price: "30.0", category: "Usecase & Tech" },
    { domain: "cryptomail.app", price: "50.0", category: "Usecase & Tech" },
    { domain: "solanad.app", price: "30.0", category: "Usecase & Tech" },
    { domain: "solananft.app", price: "99.0", category: "Usecase & Tech" },
    { domain: "solanaedu.com", price: "15.0", category: "Usecase & Tech" },
    { domain: "solanaapp.store", price: "69.0", category: "Usecase & Tech" },
    { domain: "opensource.build", price: "159.0", category: "Usecase & Tech" },
    { domain: "cryptube.vip", price: "60.0", category: "Usecase & Tech" },
    { domain: "cefi.news", price: "36.0", category: "Usecase & Tech" },
    { domain: "ethsol.world", price: "60.0", category: "Usecase & Tech" },
    { domain: "bitcoinminers.world", price: "159.0", category: "Usecase & Tech" },
    { domain: "brettsol.org", price: "15.0", category: "Usecase & Tech" },
    { domain: "pnutsol.io", price: "25.0", category: "Usecase & Tech" },
    { domain: "etfunofficial.com", price: "36.0", category: "Usecase & Tech" },
  
    // Community & Companies Category
    { domain: "shibainu.dev", price: "519.0", category: "Community & Companies" },
    { domain: "usdc.support", price: "108.0", category: "Community & Companies" },
    { domain: "chainlink.support", price: "108.0", category: "Community & Companies" },
    { domain: "memetokens.dev", price: "108.0", category: "Community & Companies" },
    { domain: "raydium.support", price: "99.0", category: "Community & Companies" },
    { domain: "shibainu.support", price: "108.0", category: "Community & Companies" },
    { domain: "pepedapp.store", price: "99.0", category: "Community & Companies" },
    { domain: "babydoge.dev", price: "159.0", category: "Community & Companies" },
    { domain: "pepecrypto.org", price: "108.0", category: "Community & Companies" },
    { domain: "shibtoken.org", price: "159.0", category: "Community & Companies" },
    { domain: "shibtoken.dev", price: "159.0", category: "Community & Companies" },
    { domain: "shibtoken.support", price: "99.0", category: "Community & Companies" },
    { domain: "memesbitcoin.com", price: "54.0", category: "Community & Companies" },
    { domain: "gpt360.support", price: "30.0", category: "Community & Companies" },
    { domain: "wldcoin.network", price: "159.0", category: "Community & Companies" },
    { domain: "bonkcoin.exchange", price: "99.0", category: "Community & Companies" },
    { domain: "troncoin.exchange", price: "99.0", category: "Community & Companies" },
    { domain: "pinksale.support", price: "60.0", category: "Community & Companies" },
    { domain: "shibd.app", price: "112.0", category: "Community & Companies" },
    { domain: "dextools.support", price: "40.0", category: "Community & Companies" },
    { domain: "dextools.academy", price: "20.0", category: "Community & Companies" },
    { domain: "dexscreener.support", price: "45.0", category: "Community & Companies" },
    { domain: "tron-coin.org", price: "60.0", category: "Community & Companies" },
    { domain: "trojan.support", price: "45.0", category: "Community & Companies" },
    { domain: "trojanbot.dev", price: "36.0", category: "Community & Companies" },
    { domain: "trojanonsol.com", price: "50.0", category: "Community & Companies" },
    { domain: "trojansol.dev", price: "45.0", category: "Community & Companies" },
    { domain: "troncoin.network", price: "108.0", category: "Community & Companies" },
    { domain: "trojansol.bot", price: "90.0", category: "Community & Companies" },
    { domain: "bonkbot.support", price: "60.0", category: "Community & Companies" },
    { domain: "chaingpt.support", price: "36.0", category: "Community & Companies" },
    { domain: "pnut.support", price: "40.0", category: "Community & Companies" },
    { domain: "dogwifhat.dev", price: "99.0", category: "Community & Companies" },
    { domain: "baby-pepe.vip", price: "19.0", category: "Community & Companies" },
    { domain: "pepe-crypto.com", price: "59.0", category: "Community & Companies" },
    { domain: "peped.app", price: "45.0", category: "Community & Companies" },
    { domain: "pepu.vip", price: "19.0", category: "Community & Companies" },
    { domain: "ponke.vip", price: "45.0", category: "Community & Companies" },
    { domain: "pnutcrypto.com", price: "19.0", category: "Community & Companies" },
    { domain: "gmesol.vip", price: "12.0", category: "Community & Companies" },
    { domain: "memes-crypto.com", price: "72.0", category: "Community & Companies" },
    { domain: "icpcoin.org", price: "109.0", category: "Usecase & Tech" },
    { domain: "suicrypto.org", price: "19.0", category: "Community & Companies" },
    { domain: "pnutelonmusk.com", price: "30.0", category: "Community & Companies" },
    { domain: "2025etfs.com", price: "45.0", category: "Community & Companies" }
  
];
  
  export default domains;
  